import React from 'react';
import * as FiIcons from 'react-icons/fi';
const { FiInbox, FiCheckCircle, FiMonitor, FiLogOut, FiShield, FiBook, FiLock, FiSave, FiUser, FiCpu, FiX, FiBarChart2, FiBookmark, FiPieChart } = FiIcons;
import SafeIcon from '../common/SafeIcon';

const Sidebar = ({ activeView, setActiveView, stats, user, onLogout, tier2Unlocked, onSaveProgress, isOpen, onClose, onShowMarketing }) => {
  const isGuest = user?.isGuest;
  
  const menuItems = [
    { id: 'queue', label: 'Service Queue', icon: FiInbox, count: stats.tier1Open },
    { id: 'tier2', label: 'Tier 2 Queue', icon: tier2Unlocked ? FiCpu : FiLock, count: tier2Unlocked ? stats.tier2Open : 0, locked: !tier2Unlocked },
    { id: 'resolved', label: 'Resolved', icon: FiCheckCircle, count: stats.resolved },
    { id: 'kb', label: 'Knowledge Base', icon: FiBook },
    { id: 'playbook', label: 'Pro Playbook', icon: FiBookmark },
    { id: 'performance', label: 'Metrics', icon: FiBarChart2 },
    { id: 'profile', label: 'My Profile', icon: FiUser },
  ];

  const handleNav = (id) => {
    setActiveView(id);
    if (window.innerWidth < 768) onClose();
  };

  return (
    <>
      <div className={`fixed inset-0 bg-slate-950/60 backdrop-blur-sm z-[60] transition-opacity duration-300 md:hidden ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} />
      <div className={`fixed md:relative inset-y-0 left-0 w-64 bg-slate-950 text-slate-400 flex flex-col h-screen border-r border-slate-900 shrink-0 z-[70] transition-transform duration-300 transform ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}>
        <div className="p-6 flex items-center justify-between text-white border-b border-slate-900/50">
          <div className="flex items-center space-x-3">
             <div className="bg-white px-4 py-3 rounded-xl shadow-lg shadow-white/5">
                <img src="https://media-manager-c.questera.ai/greta-media/c4cd7048ee42a7b0632cdf5aa1fa307c48d20f8ae20304e7af2c62d9e8bb8b361540d414afb44516657958e65ec582f9/images/aW1hZ2UvcG5n/ddfb2c5aeb3b376e9ab5a19c747ef4da.png" alt="NetDesk Pro" className="h-10 object-contain" />
             </div>
          </div>
          <button onClick={onClose} className="md:hidden p-2 text-slate-500 hover:text-white">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        <div className="flex-1 px-4 py-8 space-y-1 overflow-y-auto">
          {isGuest && (
            <button onClick={onSaveProgress} className="w-full flex items-center space-x-3 px-4 py-4 mb-6 rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-900/20 hover:scale-[1.02] transition-all" >
              <SafeIcon icon={FiSave} className="text-xl" />
              <div className="text-left">
                <div className="text-xs font-black uppercase tracking-widest">Save Progress</div>
                <div className="text-[10px] opacity-80">Sync to Cloud</div>
              </div>
            </button>
          )}

          <div className="text-[10px] font-black text-slate-600 uppercase tracking-[0.2em] mb-4 px-3">
            Control Center
          </div>

          {menuItems.map((item) => (
            <button
              key={item.id}
              disabled={item.locked}
              onClick={() => handleNav(item.id)}
              className={`w-full flex items-center justify-between px-3 py-3 rounded-xl transition-all duration-200 group ${item.locked ? 'opacity-40 cursor-not-allowed' : activeView === item.id ? 'bg-blue-600/10 text-blue-400 border border-blue-500/20' : 'hover:bg-slate-900 hover:text-slate-200'}`}
            >
              <div className="flex items-center space-x-3">
                <SafeIcon icon={item.icon} className={activeView === item.id ? 'text-blue-400' : 'text-slate-500 group-hover:text-inherit'} />
                <span className="text-sm font-bold">{item.label}</span>
              </div>
              {item.count !== undefined && item.count > 0 && (
                <span className={`text-[10px] font-black py-0.5 px-2 rounded-lg ${item.id === 'queue' ? 'bg-blue-600 text-white shadow-sm' : item.id === 'tier2' ? 'bg-indigo-600 text-white shadow-sm' : 'bg-slate-800 text-slate-400'}`}>
                  {item.count}
                </span>
              )}
            </button>
          ))}

          {/* New Marketing Guide Link in Sidebar */}
          <div className="pt-8 opacity-50">
            <div className="text-[10px] font-black text-slate-600 uppercase tracking-[0.2em] mb-4 px-3">
              Internal Only
            </div>
            <button
              onClick={onShowMarketing}
              className="w-full flex items-center space-x-3 px-3 py-3 rounded-xl hover:bg-slate-900 text-slate-500 hover:text-slate-200 transition-all"
            >
              <SafeIcon icon={FiPieChart} />
              <span className="text-sm font-bold">Marketing Guide</span>
            </button>
          </div>
        </div>

        <div className="p-4 bg-slate-900/30 border-t border-slate-900 space-y-4">
          <button onClick={onLogout} className="w-full flex items-center justify-center space-x-2 px-3 py-3 rounded-xl bg-red-500/5 text-red-500 hover:bg-red-500/10 transition-all border border-red-500/10 text-xs font-black uppercase tracking-widest" >
            <SafeIcon icon={FiLogOut} />
            <span>Exit Session</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;